import styled, { keyframes } from 'styled-components'

const scaleIn = keyframes`
  from {
    transform: translate(-50%, -50%) scale(0);
  }

  to {
    transform: translate(-50%, -50%) scale(1);
  }
`

export const Container = styled.div`
  position: fixed;
  will-change: transform;
  width: 100vw;
  height: 100vh;
`
export const Reposition = styled.div`
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  ${props =>
    props.bounds === 'half' &&
    `
    right: 50vw;
  `}
`

export const Circle = styled.div`
  background: white;
  border-radius: 50%;
  height: 15vh;
  width: 15vh;
  position: absolute;
  top: ${({ y }) => `${y}%`};
  left: ${({ x }) => `${x}%`};
  animation: ${scaleIn} 500ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transform: translate(-50%, -50%);
`
